import { Component, OnDestroy } from '@angular/core';
import { interval, of, Subscription } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { DiagnosticService } from '../../services/diagnostic.service';
import { DiagnosticInput, DiagnosticResult } from '../../models/diagnostic.models';
import { StoreAuxService } from '../../../services/storeAux/store-aux.service';

@Component({
  selector: 'app-campaign-troubleshooting',
  templateUrl: './campaign-troubleshooting.component.html',
  styleUrls: ['./campaign-troubleshooting.component.scss']
})
export class CampaignTroubleshootingComponent implements OnDestroy {
  loading = false;
  error: string | null = null;
  result: DiagnosticResult | null = null;
  ssoUrl: string | null = null;

  private lastInput: DiagnosticInput | null = null;
  private diagSub: Subscription | null = null;
  private ssoPollSub: Subscription | null = null;

  constructor(
    private readonly diagnosticService: DiagnosticService,
    readonly storeAux: StoreAuxService
  ) {}

  onSubmit(input: DiagnosticInput): void {
    this.lastInput = input;
    this.runDiagnosis(input);
  }

  onRetry(): void {
    if (this.lastInput) {
      this.runDiagnosis(this.lastInput);
    }
  }

  private runDiagnosis(input: DiagnosticInput): void {
    this.loading = true;
    this.error = null;
    this.result = null;
    this.ssoUrl = null;

    this.diagSub?.unsubscribe();
    this.startSsoPolling();

    this.diagSub = this.diagnosticService
      .diagnose(input.campaignId, input.country, input.storeId, input.storeType, input.campaignType, input.keyword)
      .subscribe({
        next: data => {
          this.result = data;
          this.stopSsoPolling();
          this.loading = false;
        },
        error: err => {
          const detail = err?.error?.detail;
          const msg = Array.isArray(detail)
            ? detail.map((e: any) => e.msg || JSON.stringify(e)).join(' · ')
            : (typeof detail === 'string' ? detail : null);
          this.error = msg || err.message || 'Error inesperado';
          this.stopSsoPolling();
          this.loading = false;
        }
      });
  }

  private startSsoPolling(): void {
    this.ssoPollSub?.unsubscribe();
    this.ssoPollSub = interval(2500).pipe(
      switchMap(() =>
        this.diagnosticService.getSsoPending().pipe(
          catchError(() => of(null))
        )
      )
    ).subscribe(data => {
      if (data) {
        this.ssoUrl = data.url || null;
      }
    });
  }

  private stopSsoPolling(): void {
    this.ssoPollSub?.unsubscribe();
    this.ssoPollSub = null;
    this.ssoUrl = null;
  }

  ngOnDestroy(): void {
    this.diagSub?.unsubscribe();
    this.stopSsoPolling();
  }
}
